// components/incognito-badge.js — Reusable incognito indicator
// Shows shield icon + text. Used in chat headers for incognito threads.

export default function IncognitoBadge({ variant = 'full', color = '#7a9e82' }) {
  const icon = (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
      <path d="M12 3a7 7 0 0 1 7 7v7l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5v-7a7 7 0 0 1 7-7z"
        stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="9" cy="11" r="1" fill={color}/>
      <circle cx="15" cy="11" r="1" fill={color}/>
    </svg>
  );

  if (variant === 'icon') return icon;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {icon}
      <span style={{ color, fontSize: 13, fontFamily: 'Georgia, serif' }}>
        Nothing Stored - Messages Deleted When You Leave/Delete The Thread.
      </span>
    </div>
  );
}
